import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import workstationService from './workstation.service';

export interface WorkstationState { }

const WorkstationStore: Module<WorkstationState, StoreState> = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async get(state, { company_id }: { company_id: number }) {
            return await workstationService.get({ company_id }).then((response) => response.data);
        },
    },
};

export default WorkstationStore;
